import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { toast } from "sonner";

const inp = "h-11 w-full rounded-xl border border-[#E2E8F0] px-3 text-sm dark:border-[#223139] dark:bg-white/5 dark:text-white";

export default function PurchaseSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [st, setSt] = useState(null);
  const [mode, setMode] = useState("register");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const hasToken = !!localStorage.getItem("contaha_token");

  useEffect(() => {
    let n = 0; let stop = false;
    const poll = async () => {
      try { const { data } = await api.get(`/public/checkout/status/${sid}`); setSt(data); if (data.payment_status === "paid" || data.status === "expired" || ++n > 15) return; } catch { setSt({ payment_status: "error" }); return; }
      if (!stop) setTimeout(poll, 2000);
    };
    if (sid) poll();
    return () => { stop = true; };
  }, [sid]);
  useEffect(() => { if (st?.buyer_email && !f.email) setF((x) => ({ ...x, email: st.buyer_email })); }, [st]); // eslint-disable-line react-hooks/exhaustive-deps

  const claim = async () => {
    await api.post("/public/purchases/claim", { session_id: sid, claim_token: localStorage.getItem(`contaha_claim_${sid}`) || "" });
    toast.success("Subscription activated"); window.location.href = "/";
  };
  const submit = async () => {
    setBusy(true);
    try {
      if (!hasToken) {
        const { data } = await api.post(mode === "register" ? "/auth/register" : "/auth/login", mode === "register" ? f : { email: f.email, password: f.password });
        localStorage.setItem("contaha_token", data.token);
      }
      await claim();
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't activate"); setBusy(false); }
  };
  const paid = st?.payment_status === "paid";
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4FBF7] px-4 py-10 dark:bg-[#0B141A]">
      <div className="w-full max-w-md rounded-3xl border border-[#E2E8F0] bg-white p-8 dark:border-[#223139] dark:bg-[#0E1A21]" data-testid="purchase-success-page">
        <div className="mb-6 text-xl font-extrabold tracking-wide text-[#101516] dark:text-white">CON<span className="text-[#00A85A]">TAHA</span></div>
        {!st || (!paid && st.payment_status === "pending" && st.status !== "expired") ? <p className="flex items-center gap-2 text-sm" data-testid="purchase-pending"><Loader2 className="h-4 w-4 animate-spin text-[#00A85A]" />Confirming your payment…</p> : null}
        {st && !paid && (st.status === "expired" || st.payment_status === "error") && <p className="flex items-center gap-2 text-sm text-red-600" data-testid="purchase-failed"><XCircle className="h-4 w-4" />Payment was not completed.</p>}
        {paid && (
          <>
            <p className="flex items-center gap-2 text-lg font-bold text-[#008F4D]" data-testid="purchase-paid"><CheckCircle2 className="h-5 w-5" />Payment confirmed · {st.plan_name}</p>
            {st.claimed ? <Button className="mt-5 w-full bg-[#00A85A] text-white" onClick={() => { window.location.href = "/"; }}>Go to CONTAHA</Button> : (
              <div className="mt-5 space-y-3">
                <p className="text-sm text-[#687173]">{hasToken ? "Activate this subscription on your signed-in account." : "Create your CONTAHA account or sign in to activate it."}</p>
                {!hasToken && <>
                  <div className="flex gap-2 text-xs font-semibold">{["register", "login"].map((m) => <button key={m} type="button" onClick={() => setMode(m)} data-testid={`purchase-mode-${m}`} className={`rounded-lg px-3 py-1.5 ${mode === m ? "bg-[#00A85A] text-white" : "bg-[#F4FBF7]"}`}>{m === "register" ? "Create account" : "Sign in"}</button>)}</div>
                  {mode === "register" && <input className={inp} placeholder="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="purchase-name" />}
                  <input className={inp} type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="purchase-email" />
                  <input className={inp} type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="purchase-password" />
                </>}
                <Button onClick={submit} disabled={busy} className="h-11 w-full rounded-xl bg-[#00A85A] text-white hover:bg-[#008F4D]" data-testid="purchase-activate">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Activate subscription</Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
